import { createContext, useContext } from 'react';

export interface ScrollRestorationContextValue {
  /**
   * Asks for the page at the url to be shown at the scroll position it was last left at, if the navigation that is
   * about to happen goes to exactly that url - instead of at the top, as every other navigation is. For links "up"
   * to a page that the user came from, which are not the browser's Back, e.g. breadcrumbs (see BreadcrumbLink).
   *
   * The request only lasts until the current event has been handled, so it can only be used by the navigation made
   * by that same event (e.g. the click on the link).
   */
  restoreOnNextNavigation: (url: string) => void
}

// Does nothing by default, so that what uses it also works outside of ScrollRestoration
export const ScrollRestorationContext = createContext<ScrollRestorationContextValue>({
  restoreOnNextNavigation: () => {}
});

export const useScrollRestorationContext = () => useContext(ScrollRestorationContext);
